var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5498 1.75659C0.859449 1.75659 0.299805 2.31624 0.299805 3.00659V13.8811C0.299805 14.5715 0.859451 15.1311 1.54981 15.1311H3.17255C3.25377 16.0222 4.003 16.7202 4.91525 16.7202C5.82751 16.7202 6.57673 16.0222 6.65796 15.1311H10.742H11.7206C11.8018 16.0222 12.551 16.7202 13.4633 16.7202C14.3755 16.7202 15.1247 16.0222 15.206 15.1311H16.45C17.1404 15.1311 17.7 14.5715 17.7 13.8811V9.26487C17.7 8.931 17.5665 8.61101 17.3291 8.37621L14.8945 5.96791C14.6605 5.73641 14.3446 5.60657 14.0155 5.60657H12.242V3.00659C12.242 2.31623 11.6823 1.75659 10.992 1.75659H1.5498ZM1.7998 13.6311V3.25659H10.742V13.6311H1.7998ZM16.2 9.36922L13.9127 7.10657H12.242V13.6311H16.2V9.36922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseSend);
export default __webpack_public_path__ + "static/media/purchaseSend.705112d979d3808790136116d4de9cfe.svg";
export { ForwardRef as ReactComponent };